<bs-modal
  #XVIModalWrapper
  [cssClass]="widgetData?.cssClass"
  [keyboard]="widgetData?.keyboard || false"
  [backdrop]="widgetData?.backdrop || 'static'"
  (onDismiss)="onCancel.emit()"
  [attr.data-e2e-id]="modalId"
>
  <bs-modal-header>
    <b>{{ title }}</b>
  </bs-modal-header>
  <div class="pull-right toolbar-btns">
    <xvi-toolbar [buttons]="headerButtons"></xvi-toolbar>
  </div>
  <bs-modal-body>
    <ng-content> </ng-content>
  </bs-modal-body>
  <bs-modal-footer *ngIf="!!footerButtons.length">
    <xvi-toolbar [buttons]="footerButtons"></xvi-toolbar>
  </bs-modal-footer>
</bs-modal>
